import { confirm } from "../../common/ConfirmModal";

// The one definition of "there is a Q code here and nothing to bill its application
// with", shared by the note badge, the editor badge and the save confirmation so
// they can't disagree. `key` is the editor's live selection; `code` is stamped from
// it on save. Note generation writes cpt2Wounds as plain "CODE - description"
// strings, which have neither and so never count as missing a CPT.
export const isMissingCpt = (qcode) => Boolean(qcode?.code || qcode?.key) && !qcode.cpt?.length;

// Shared by both places a Q code gets saved: the Q code editor's own Save (note
// view) and ModalEditTable's Update (table view, via the cpt2Wounds column).
//
// Resolves true when the save should go ahead: there is no Q code to bill, it has
// a CPT attached, or the provider chose "Save anyway". A warning, not a block --
// the claim form bills only the CPTs attached to the Q code, but the provider may
// be mid-documentation or billing the procedure elsewhere.
export const confirmMissingCpt = async (qcode, t) => {
  if (!isMissingCpt(qcode)) return true;

  return confirm({
    title: t("chatEdit.qcodes.noCptConfirmTitle"),
    message: t("chatEdit.qcodes.noCptConfirmMessage"),
    showCancel: true,
    titleConfirm: t("chatEdit.qcodes.noCptSaveAnyway"),
    titleCancel: t("chatEdit.qcodes.noCptGoBack"),
  });
};
